import { render, staticRenderFns } from "./AllocationDoughnuts.vue?vue&type=template&id=7feb1126&lang=pug"
import script from "./AllocationDoughnuts.vue?vue&type=script&lang=js"
export * from "./AllocationDoughnuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports